/**
 * MINIMOSAIC — theme.js
 * Global JS API (Agent A). See design-reference/CONVENTIONS.md "Global JS API".
 */
(function () {
  'use strict';

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------- Toast notifications ----------------
     Themed replacement for window.alert()/confirm(). Any part of the theme
     can call window.mmToast(message, { variant, title, duration }) to show
     a dismissible, on-brand notification instead of a native browser dialog.
     variant: 'info' (default) | 'success' | 'error'
  */
  function getToastRegion() {
    var region = document.getElementById('mm-toast-region');
    if (!region) {
      region = document.createElement('div');
      region.id = 'mm-toast-region';
      region.className = 'mm-toast-region';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      document.body.appendChild(region);
    }
    return region;
  }

  window.mmToast = function (message, options) {
    if (!message) return null;
    options = options || {};
    var variant = options.variant || 'info';
    var title = options.title || (variant === 'error' ? 'HEADS UP' : variant === 'success' ? 'DONE' : 'NOTE');
    var duration = typeof options.duration === 'number' ? options.duration : 4200;
    var region = getToastRegion();

    var toast = document.createElement('div');
    toast.className = 'mm-toast mm-toast--' + variant;
    toast.setAttribute('role', variant === 'error' ? 'alert' : 'status');

    var icon = document.createElement('div');
    icon.className = 'mm-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = variant === 'error' ? '!' : variant === 'success' ? '♥' : 'i';

    var body = document.createElement('div');
    body.className = 'mm-toast__body';

    var titleEl = document.createElement('div');
    titleEl.className = 'mm-toast__title';
    titleEl.textContent = title;

    var msgEl = document.createElement('div');
    msgEl.className = 'mm-toast__message';
    msgEl.textContent = message;

    body.appendChild(titleEl);
    body.appendChild(msgEl);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'mm-toast__close';
    closeBtn.setAttribute('aria-label', 'Dismiss notification');
    closeBtn.textContent = '×';

    toast.appendChild(icon);
    toast.appendChild(body);
    toast.appendChild(closeBtn);
    region.appendChild(toast);

    // Cap the stack so a burst of errors can't paper the screen.
    while (region.children.length > 4) {
      region.removeChild(region.firstElementChild);
    }

    requestAnimationFrame(function () {
      toast.classList.add('mm-toast--visible');
    });

    var dismissed = false;
    var timer;
    function dismiss() {
      if (dismissed) return;
      dismissed = true;
      clearTimeout(timer);
      toast.classList.remove('mm-toast--visible');
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 200);
    }

    closeBtn.addEventListener('click', dismiss);
    if (duration > 0) {
      timer = setTimeout(dismiss, duration);
      toast.addEventListener('mouseenter', function () { clearTimeout(timer); });
      toast.addEventListener('mouseleave', function () { timer = setTimeout(dismiss, 1600); });
    }

    return { dismiss: dismiss, el: toast };
  };

  /* ---------------- Cart drawer web component ---------------- */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-mm-drawer-close]')) {
          this.close();
        }
      });
    }
    open() {
      this.setAttribute('open', '');
      this.classList.add('mm-is-open');
      document.documentElement.classList.add('mm-scroll-lock');
      var scrim = document.querySelector('[data-mm-cart-scrim]');
      if (scrim) scrim.hidden = false;
      var closeBtn = this.querySelector('[data-mm-drawer-close]');
      if (closeBtn) closeBtn.focus();
    }
    close() {
      this.removeAttribute('open');
      this.classList.remove('mm-is-open');
      document.documentElement.classList.remove('mm-scroll-lock');
      var scrim = document.querySelector('[data-mm-cart-scrim]');
      if (scrim) scrim.hidden = true;
    }
    refresh() {
      var self = this;
      return fetch(routeRoot + '?section_id=cart-drawer')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newDrawer = doc.querySelector('cart-drawer');
          if (newDrawer) {
            self.innerHTML = newDrawer.innerHTML;
          }
          updateCartCount();
        })
        .catch(function (err) { console.error('[mm] cart drawer refresh failed', err); });
    }
  }
  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function updateCartCount() {
    fetch(routeRoot + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-mm-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* Refresh the full-page cart (if present) in place, without a page
     reload, so an open cart drawer stays open. */
  function refreshCartPage() {
    var pageEl = document.querySelector('[data-mm-cart-page]');
    if (!pageEl) return Promise.resolve();
    return fetch(window.location.href, { headers: { Accept: 'text/html' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-mm-cart-page]');
        var current = document.querySelector('[data-mm-cart-page]');
        if (fresh && current) {
          current.replaceWith(fresh);
        }
      })
      .catch(function (err) { console.error('[mm] cart page refresh failed', err); });
  }

  document.addEventListener('mm:cart:open', function () {
    var drawer = getCartDrawer();
    if (drawer) drawer.open();
  });

  /* ---------------- Generic drawers (mobile nav etc.) ---------------- */
  function openDrawerById(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('open', '');
    el.classList.add('mm-is-open');
    document.documentElement.classList.add('mm-scroll-lock');
    var scrim = document.querySelector('[data-mm-drawer-scrim="' + id + '"]') || document.querySelector('[data-mm-scrim]');
    if (scrim) scrim.hidden = false;
  }
  function closeDrawerEl(el) {
    if (!el) return;
    el.removeAttribute('open');
    el.classList.remove('mm-is-open');
    document.documentElement.classList.remove('mm-scroll-lock');
    var id = el.id;
    var scrim = document.querySelector('[data-mm-drawer-scrim="' + id + '"]') || document.querySelector('[data-mm-scrim]');
    if (scrim) scrim.hidden = true;
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-mm-drawer-open]');
    if (openTrigger) {
      e.preventDefault();
      var targetId = openTrigger.getAttribute('data-mm-drawer-open');
      if (targetId === 'cart-drawer' || targetId === 'cart') {
        document.dispatchEvent(new CustomEvent('mm:cart:open'));
      } else {
        openDrawerById(targetId);
      }
      return;
    }
    var closeTrigger = e.target.closest('[data-mm-drawer-close]');
    if (closeTrigger) {
      e.preventDefault();
      var cartDrawer = closeTrigger.closest('cart-drawer');
      if (cartDrawer) {
        cartDrawer.close();
        return;
      }
      var drawerEl = closeTrigger.closest('[data-mm-drawer]');
      if (drawerEl) {
        closeDrawerEl(drawerEl);
      }
      return;
    }
    var scrimEl = e.target.closest('[data-mm-scrim], [data-mm-cart-scrim], [data-mm-drawer-scrim]');
    if (scrimEl) {
      var cd = getCartDrawer();
      if (cd && (cd.hasAttribute('open') || cd.classList.contains('mm-is-open'))) cd.close();
      document.querySelectorAll('[data-mm-drawer].mm-is-open, [data-mm-drawer][open]').forEach(closeDrawerEl);
      if (scrimEl.hasAttribute('data-mm-scrim') || scrimEl.hasAttribute('data-mm-cart-scrim') || scrimEl.hasAttribute('data-mm-drawer-scrim')) {
        scrimEl.hidden = true;
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var cd = getCartDrawer();
    if (cd && (cd.hasAttribute('open') || cd.classList.contains('mm-is-open'))) {
      cd.close();
      return;
    }
    document.querySelectorAll('[data-mm-drawer].mm-is-open, [data-mm-drawer][open]').forEach(closeDrawerEl);
  });

  /* ---------------- Ajax add-to-cart ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-mm-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          // Shopify error response (e.g. item just sold out) — show a themed
          // toast instead of falling back to a full-page reload.
          console.error('[mm] add to cart error', data);
          window.mmToast(data.description || data.message || 'Could not add that item to your cart.', {
            variant: 'error',
            title: "COULDN'T ADD TO CART"
          });
          return;
        }
        var drawer = getCartDrawer();
        if (drawer) {
          drawer.refresh().then(function () { drawer.open(); });
        } else {
          updateCartCount();
        }
        // Keep the full-page cart (if we're on it) in sync without a reload,
        // so the drawer stays open.
        refreshCartPage();
      })
      .catch(function (err) {
        console.error('[mm] ajax add to cart failed, falling back to normal submit', err);
        form.submit();
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  /* ---------------- Steppers ---------------- */
  function stepperInput(stepper) {
    return stepper.querySelector('input');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-minus], [data-plus]');
    if (!btn) return;
    var stepper = btn.closest('[data-mm-stepper]');
    if (!stepper) return;
    var input = stepperInput(stepper);
    if (!input) return;

    var min = parseInt(input.getAttribute('min') || '0', 10);
    var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;
    var value = parseInt(input.value || '1', 10);

    if (btn.hasAttribute('data-minus')) value = Math.max(min, value - 1);
    if (btn.hasAttribute('data-plus')) value = Math.min(max, value + 1);

    input.value = value;
    var valEl = stepper.querySelector('.mm-stepper__val');
    if (valEl) valEl.textContent = value;

    var line = stepper.getAttribute('data-line');
    if (line) {
      updateCartLine(line, value, stepper);
    } else {
      stepper.dispatchEvent(new CustomEvent('mm:stepper:change', { bubbles: true, detail: { value: value } }));
    }
  });

  /* Human-readable name for a cart line, e.g. "Series A (A1 / 500 pcs)". */
  function cartItemLabel(item) {
    var name = item.product_title || 'this item';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      name += ' (' + item.variant_title + ')';
    }
    return name;
  }

  function updateCartLine(line, quantity, stepper) {
    stepper.classList.add('mm-is-loading');
    var lineIndex = parseInt(line, 10);
    fetch(routeRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && (data.errors || data.status)) {
          var errMsg = data.description
            || (typeof data.errors === 'string' ? data.errors : null)
            || data.message
            || "That item couldn't be updated.";
          // Shopify's stock cap comes back as an error like
          // "Only 25 items were added to your cart due to availability."
          // That's a limit, not a failure — present it as one.
          var stockCap = /availability|in stock|only \d+/i.test(errMsg);
          if (stockCap) {
            var m = errMsg.match(/\d+/);
            var qty = m ? m[0] : '';
            window.mmToast(
              (qty ? 'Only ' + qty + ' in stock' : 'No more in stock') + " — they're all in your cart. · 库存仅剩 " + qty + " 件，已全部加入购物车",
              { variant: 'info', title: 'MAX STOCK REACHED', duration: 5000 }
            );
          } else {
            window.mmToast(errMsg, {
              variant: 'error',
              title: "COULDN'T UPDATE CART"
            });
          }
        } else if (data && data.items && quantity > 0) {
          // Shopify does NOT error when you ask for more than is in stock —
          // it silently caps the line at the available quantity and returns
          // 200. Compare what we asked for with what the cart now holds so
          // the customer is told why the stepper snapped back.
          var item = data.items[lineIndex - 1];
          if (item && item.quantity < quantity) {
            window.mmToast(
              'Only ' + item.quantity + ' in stock for ' + cartItemLabel(item) +
              " — they're all in your cart. · 库存仅剩 " + item.quantity + " 件，已全部加入购物车",
              { variant: 'info', title: 'MAX STOCK REACHED', duration: 5000 }
            );
          }
        }
        var drawer = getCartDrawer();
        if (drawer && (drawer.hasAttribute('open') || drawer.classList.contains('mm-is-open'))) {
          drawer.refresh();
        } else {
          updateCartCount();
        }
        // Refresh the full-page cart in place (no reload) so an open
        // cart drawer is never closed by a quantity change.
        refreshCartPage();
      })
      .catch(function (err) { console.error('[mm] cart/change.js failed', err); })
      .finally(function () { stepper.classList.remove('mm-is-loading'); });
  }

  /* ---------------- Remove links (cart drawer + cart page) ----------------
     REMOVE used to be a plain link to /cart/change?line=N&quantity=0, which
     sends the shopper to the /cart page. Intercept it and remove the line
     in place with cart/change.js instead; the drawer (or cart page) then
     refreshes itself and stays where it is. The link still works without JS. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.mm-cart-line__remove');
    if (!link) return;
    var lineEl = link.closest('.mm-cart-line');
    var stepper = lineEl ? lineEl.querySelector('[data-mm-stepper][data-line]') : null;
    if (!stepper) return;
    e.preventDefault();
    if (lineEl.classList.contains('mm-is-removing')) return;
    lineEl.classList.add('mm-is-removing');
    lineEl.style.opacity = '.45';
    lineEl.style.pointerEvents = 'none';

    fetch(routeRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(stepper.getAttribute('data-line'), 10), quantity: 0 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/change.js ' + res.status);
        return res.json();
      })
      .then(function () {
        var drawer = getCartDrawer();
        var jobs = [refreshCartPage()];
        if (drawer) jobs.push(drawer.refresh()); else updateCartCount();
        return Promise.all(jobs);
      })
      .catch(function (err) {
        console.error('[mm] remove from cart failed', err);
        lineEl.classList.remove('mm-is-removing');
        lineEl.style.opacity = '';
        lineEl.style.pointerEvents = '';
        window.mmToast("That item couldn't be removed. Please try again. · 删除失败，请重试", {
          variant: 'error',
          title: "COULDN'T UPDATE CART"
        });
      });
  });

  /* ---------------- Init ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    updateCartCount();
  });
})();